<div [matTooltipClass]="{'uzai-tooltip':true}" [matTooltip]="tooltip" [matTooltipDisabled]="disabled">
    <ng-content></ng-content>
</div>